export const SENTRY_DSN = __BROWSER__ ? window.__config.SENTRY_DSN : null;
export const RECAPTCHA_API_KEY = process.env.REACT_APP_RECAPTCHA_API_KEY;
export const API_URL = process.env.REACT_APP_API_URL;
